import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '../../../core/directives/directives.module';
import { DialogAlertModule } from './dialog-alert/dialog-alert.module';
import { DialogRecurrencesComponent } from './dialog-recurrences.component';
import { TabGeneralModule } from './tabs/general/tab-general.module';
import { TabHistoricModule } from './tabs/historic/tab-historic.module';
import { TabLinksModule } from './tabs/links/tab-links.module';
import { TabOccurrencesModule } from './tabs/occurrences/tab-occurrences.module';

@NgModule({
  entryComponents: [
    DialogRecurrencesComponent
  ],
  declarations: [
    DialogRecurrencesComponent,
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatToolbarModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    TabGeneralModule,
    TabOccurrencesModule,
    TabHistoricModule,
    DialogAlertModule,
    DisclaimerModule,
    TabLinksModule,
    DirectivesModule
  ],
  exports: [
    DialogRecurrencesComponent,
  ],
})
export class DialogRecurrencesModule {}
